import type { KadeweUser } from "~/types";

/**
 * Active maintenance modes keyed by slug, with an optional custom message (null means the default text should be
 * shown). Filled by the maintenance.global middleware.
 */
export const useMaintenanceModes = () => useState<Record<string, string | null>>("maintenanceModes", () => ({}));

/**
 * Maintenance state of a portal page (e.g. "/portal/card" -> "card") for the current user.
 */
export const usePortalMaintenance = () => {
    const user = useSanctumUser<KadeweUser>();
    const maintenanceModes = useMaintenanceModes();

    const slug = (path: string): string => path.split("/portal/")[1] || "";

    return {
        isActive: (path: string): boolean =>
            !!user.value && !user.value.can_bypass_maintenance && slug(path) in maintenanceModes.value,
        message: (path: string): string | null => maintenanceModes.value[slug(path)] ?? null,
    };
};
